export default "__VITE_ASSET__Cp9oZ1Se__"